module.exports = __webpack_public_path__ + "static/img/SPLAT_Horizontal.46acdd2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logos/SPLAT_Horizontal.png
// module id = 168
// module chunks = 4